<template>
    <div class="placeholder fit-content">
        <div class="placeholder__heading">
            <d-tooltip placement="left" identifier="oekonomi.leverandoerer" />
            Leverandører
        </div>
        <div class="placeholder">
            
            <vue-good-table
                :columns="columns"
                :rows="rows"
                :search-options="searchOptions"
                :pagination-options="paginationOptions"
                :sort-options="sortOptions"
                :styleClass="styleClass"
                v-if="!loading"
            >
                <div slot="emptystate">
                    Ingen data ...
                </div>
                <template slot="table-row" slot-scope="props">
                    <div v-if="props.column.field == 'name'" class="table-column__description">
                        {{ props.row.name }}
                    </div>
                    <div v-else-if="props.column.field == 'total_quantity'" style="text-align:left;">
                        {{ props.row.total_quantity | number }}
                    </div>
                    <div v-else-if="props.column.field == 'total_cost'" style="text-align:left;">
                        {{ props.row.total_cost | currency }}
                    </div>
                    <div v-else-if="props.column.field == 'avg_price_per_material'" style="text-align:left;">
                        {{ props.row.avg_price_per_material | currency }}
                    </div>
                    <div v-else>
                        {{ props.formattedRow[props.column.field] }}
                    </div>
                </template>
            </vue-good-table>

            <box-loading height="350" v-else />

        </div>
    </div>
</template>

<script>
import * as economyService from '@/services/economyService'

export default {
    data () {
        return {
            loading: true,
            rows: [],
            columns: [
                { label: 'Navn', field: 'name', type: 'string' },
                { label: 'Antal købt', field: 'total_quantity', type: 'number' },
                { label: 'Total købspris', field: 'total_cost', type: 'number' },
                { label: 'Kostpris pr. enhed (gns)', field: 'avg_price_per_material', type: 'number' }
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 15,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'total_cost',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
            /* params: {
                'filter[status]': 'unbilled,billed,posted',
                'include': 'customer,type'
            } */
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid
            }
            economyService.suppliers(params, (response) => {
                this.rows = response.data
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// suppliers.vue?c04a6b3e